import { Currency } from '@commercetools/frontend-sdk/lib/types/Currency';

interface LocalizationMapping {
  locale: string;
  currency: Currency;
  currencyCode: string;
  countryName: string;
  countryCode: string;
  countryKey: string;
}

const localizationMapper = {
  au: {
    locale: 'en_AU',
    currency: 'AUD',
    currencyCode: '$A',
    countryCode: 'AU',
    countryName: 'Australia',
    countryKey: 'au',
  },
  nz: {
    locale: 'en_NZ',
    currency: 'NZD',
    currencyCode: '$',
    countryCode: 'NZ',
    countryName: 'New Zealand',
    countryKey: 'nz',
  },
  uk: {
    locale: 'en_GB',
    currency: 'GBP',
    currencyCode: '£',
    countryCode: 'UK',
    countryName: 'United Kingdom',
    countryKey: 'uk',
  },
} as Record<string, LocalizationMapping>;

export const getLocalizationInfo = (locale: string) => {
  if (!(locale in localizationMapper)) {
    console.warn(
      `Invalid locale ${locale} provided. Possible values are ${Object.keys(localizationMapper).join(', ')}`,
    );

    return localizationMapper.au;
  }

  return localizationMapper[locale as keyof typeof localizationMapper];
};
